export default __webpack_public_path__ + "static/media/cancelIcon.17e401c8.svg";